import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function UserLoveStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M13.75 7.5C13.75 5.1528 11.8472 3.25 9.5 3.25C7.15279 3.25 5.25 5.15279 5.25 7.5C5.25 9.84719 7.1528 11.75 9.5 11.75C11.8472 11.75 13.75 9.84719 13.75 7.5ZM15.25 7.5C15.25 10.6756 12.6756 13.25 9.5 13.25C6.32436 13.25 3.75 10.6756 3.75 7.5C3.75 4.32437 6.32437 1.75 9.5 1.75C12.6756 1.75 15.25 4.32436 15.25 7.5Z"
				fill="currentColor"
			/>
			<path
				d="M1.75 19.5C1.75 15.2198 5.2198 11.75 9.5 11.75C10.6873 11.75 11.8146 12.0175 12.8223 12.4961C13.196 12.6739 13.3551 13.1212 13.1777 13.4951C13 13.8693 12.5519 14.0283 12.1777 13.8506C11.367 13.4656 10.4597 13.25 9.5 13.25C6.04822 13.25 3.25 16.0482 3.25 19.5C3.25 19.9142 2.91421 20.25 2.5 20.25C2.08579 20.25 1.75 19.9142 1.75 19.5Z"
				fill="currentColor"
			/>
			<path
				d="M20.75 16.6387C20.7499 15.8099 20.1844 15.25 19.5 15.25C19.1382 15.25 18.8875 15.3271 18.7002 15.4443C18.5113 15.5626 18.3318 15.7567 18.168 16.0771C18.0397 16.3278 17.7816 16.4854 17.5 16.4854C17.2184 16.4854 16.9603 16.3278 16.832 16.0771C16.6682 15.7567 16.4887 15.5626 16.2998 15.4443C16.1125 15.3271 15.8618 15.25 15.5 15.25C14.8156 15.25 14.2501 15.8099 14.25 16.6387C14.25 17.8022 15.033 18.8262 15.9824 19.623C16.442 20.0087 16.9057 20.3115 17.2559 20.5176C17.3453 20.5702 17.4285 20.6131 17.5 20.6523C17.5715 20.6131 17.6547 20.5702 17.7441 20.5176C18.0943 20.3115 18.558 20.0087 19.0176 19.623C19.967 18.8262 20.75 17.8022 20.75 16.6387ZM22.25 16.6387C22.25 18.4834 21.033 19.8908 19.9824 20.7725C19.4423 21.2258 18.9056 21.5743 18.5059 21.8096C18.3052 21.9277 18.1366 22.019 18.0166 22.0811C17.9566 22.1121 17.9082 22.1357 17.874 22.1523C17.857 22.1607 17.8429 22.1672 17.833 22.1719L17.8154 22.1807C17.6404 22.2618 17.4416 22.2718 17.2607 22.2109L17.1846 22.1807L17.167 22.1719C17.1571 22.1672 17.143 22.1607 17.126 22.1523C17.0918 22.1357 17.0434 22.1121 16.9834 22.0811C16.8634 22.019 16.6948 21.9277 16.4941 21.8096C16.0944 21.5743 15.5577 21.2258 15.0176 20.7725C13.967 19.8908 12.75 18.4834 12.75 16.6387C12.7501 15.1051 13.8687 13.75 15.5 13.75C16.0856 13.75 16.6252 13.8783 17.0957 14.1729C17.2426 14.2648 17.3761 14.3713 17.5 14.4873C17.6239 14.3713 17.7574 14.2648 17.9043 14.1729C18.3748 13.8783 18.9144 13.75 19.5 13.75C21.1313 13.75 22.2499 15.1051 22.25 16.6387Z"
				fill="currentColor"
			/>
		</svg>
	);
}

UserLoveStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default UserLoveStrokeIcon;
